import { CompanyPositions } from './enums/CompanyPositions';

export const SUPPORTED_OPPORTUNITY_COMPANY_ROLE_IDS: readonly number[] = [
    CompanyPositions.Customer,
    CompanyPositions.BidRecipient,
    CompanyPositions.CompetingBidder,
    CompanyPositions.ContractWith,
    CompanyPositions.PrimeContractor,
    CompanyPositions.ConsultingEngineer,
    CompanyPositions.Architect
];
